// "The saved decks a deck box can be Built from may have changed": the one
// signal every writer sends, so the Decks row on the shelf (useBuiltDecks)
// re-reads its lightweight owner-scoped list without a remount.
//
// Sent by: the saved-deck delete (useSavedDecks.removeDeck), the shelf's
// Recreate deck once it settles, and the deck-box runner (lane W4) after
// each commit. No payload: the listener just refetches.
//
// A plain module (no React, no Supabase) so any writer can import it without
// pulling the shelf in.

type Listener = () => void
const listeners = new Set<Listener>()

export function invalidateBuiltDecks(): void {
  for (const l of [...listeners]) {
    try { l() } catch { /* one listener never stops another */ }
  }
}

/** Subscribe; returns the unsubscribe. */
export function onBuiltDecksInvalidated(listener: Listener): () => void {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}
